<template>
    <transition name="fade" mode="out-in">
        <Survey v-if="currentStage == 1" @next="setStage(2)" :lisaType="$route.params.lisaType" :ssid="$route.params.ssid"></Survey>
        <AfterSurvey v-if="currentStage == 2"></AfterSurvey>
    </transition>
</template>

<script>
    import Survey from '../components/configurator/survey/Survey.vue';
    import AfterSurvey from '../components/configurator/survey/AfterSurvey.vue';

    export default {
        components: {
            Survey,
            AfterSurvey
        },
        data(){
            return {
                currentStage: 1
            }
        },
        methods: {
            setStage(stage){
                this.currentStage = stage
            }
        }
    }
</script>

<style scoped lang="scss">
</style>
